



































import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({ name: 'GStudentImportPreCheck' })
export default class GStudentImportPreCheck extends Vue {
  checkedItems: boolean[] = [false, false, false, false];

  readonly checkItems = [
    'ログインIDに受検結果が紐づくため、一度登録したら変更はできません。',
    '登録済みの児童・生徒・学生のログインIDは変えられません。変更した場合、過去の受検結果を引き継げなくなります。',
    '過去に登録した児童・生徒・学生と同じログインIDは使用できません。',
    'ログインIDにメールアドレスや「@」などの記号は使用できません。',
  ];

  get confirmedCount(): number {
    return this.checkedItems.filter(Boolean).length;
  }

  get allChecked(): boolean {
    return this.checkedItems.every(Boolean);
  }

  @Watch('allChecked')
  onAllCheckedChange(v: boolean) {
    this.$emit('checkedChange', v);
  }

  toggle(index: number) {
    this.$set(this.checkedItems, index, !this.checkedItems[index]);
  }
}
